import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import AdminPortal from "./AdminPortal";

createRoot(document.getElementById("tmt-event-admin-portal")).render(
  <StrictMode>
    <AdminPortal />
  </StrictMode>
);
